import "./cardGroup.sass";

const STAT_KEYS = ["pj", "g", "e", "p"];

export default function CardGroup({ row, index, isBestThird = false }) {
  const isQualified = index < 2 && row.pj > 0 && row.pts > 0;

  const clase = ["StandingsRow", isQualified && "is-qualified", isBestThird && "is-best-third"]
    .filter(Boolean)
    .join(" ");

  return (
    <div key={row.team} className={clase}>
      <div className="RowPosition">
        <span className="Position">{row.pos}</span>
        <div className={`bandera-${row.flag}`}></div>
        <span className="TeamName">{row.team}</span>
      </div>
      <div className="RowStats">
        {STAT_KEYS.map((key) => (
          <span key={key}>{row[key]}</span>
        ))}
        <span>{(() => { const d = Number(row.diff); return d > 0 ? `+${d}` : String(d); })()}</span>
        <span className="PtsValue">{row.pts}</span>
      </div>
    </div>
  );
}